import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import WorkerHome from "@/pages/WorkerHome";
import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/Dashboard";
import Production from "@/pages/Production";
import Materials from "@/pages/Materials";
import Genset from "@/pages/Genset";
import Attendance from "@/pages/Attendance";
import Schedule from "@/pages/Schedule";
import Users from "@/pages/Users";
import Dispatch from "@/pages/Dispatch";
import Stock from "@/pages/Stock";
import Purchases from "@/pages/Purchases";
import Costs from "@/pages/Costs";
import Reports from "@/pages/Reports";
import Chat from "@/pages/Chat";
import Catalog from "@/pages/Catalog";
import Landing from "@/pages/Landing";
import Account from "@/pages/Account";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleRedirect() {
  const { user } = useAuth();
  if (!user) return <Landing />;
  if (user.role === "worker") return <Navigate to="/worker" replace />;
  return <Navigate to="/admin" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleRedirect />} />
          <Route path="/worker" element={<Protected roles={["worker", "supervisor", "admin"]}><WorkerHome /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin", "supervisor"]}><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="production" element={<Production />} />
            <Route path="materials" element={<Materials />} />
            <Route path="genset" element={<Genset />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="users" element={<Users />} />
            <Route path="dispatch" element={<Dispatch />} />
            <Route path="stock" element={<Stock />} />
            <Route path="purchases" element={<Purchases />} />
            <Route path="costs" element={<Protected roles={["admin"]}><Costs /></Protected>} />
            <Route path="reports" element={<Protected roles={["admin"]}><Reports /></Protected>} />
            <Route path="chat" element={<Chat />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="account" element={<Account />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
